// @flow
import { handleResponseOld, makeGet } from './helpers';

type FetchAboutDataParams = {
    deployment: string,
};

type FetchHomeDataParams = {
    authToken: string,
    deployment: string,
    forceUpdate: boolean,
};

export default {
    fetchAboutData: ({ deployment }: FetchAboutDataParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ deployment, path: '<ITEM-API>spapage/about' });
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
    fetchHomeData: ({ authToken, deployment, forceUpdate }: FetchHomeDataParams) =>
        new Promise<any>((resolve, reject) => {
            const request = makeGet({ authToken, deployment, path: '<ITEM-API>spapage/home' });
            const query = {};
            query.bust = true;
            query.trendingLimit = 20;

            if (forceUpdate) {
                query.bustLocalCache = Date.now();
            }
            request.query(query);
            request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
        }),
};
